import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import './technical-indicators.ui.scss';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import { MandateType } from '../../../services/dtos/mandate.dto';
import TechnicalIndicatorsDataUi from './technical-indicators-data.ui';

/**
 * Vue pour l'affichage de l'onglet indicateurs techniques.
 * @param props props de l'ihm
 * @constructor
 */
export default function TechnicalIndicatorsUi(
    props: Readonly<{
        mandate?: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
        mandateType?: string | null;
    }>
) {
    return (
        <Grid container className={'tab-content technical-indicators'} rowSpacing={2}>
            <Grid item xs={12}>
                <Box className={'technical-indicators__header'}>
                    <Typography variant="h3" className={'title technical-indicators__pageTitle'}>
                        Indicateurs Techniques
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                {renderIndicatorSections(props.mandate, props.mandateType)}
            </Grid>
        </Grid>
    );
}

function renderIndicatorSections(
    mandate: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto | undefined,
    mandateType?: string | null
) {
    switch (mandateType) {
        case MandateType.EAU:
            return <TechnicalIndicatorsDataUi mandate={mandate} type={'eau'} title={false} />;
        case MandateType.ASSAINISSEMENT:
            return <TechnicalIndicatorsDataUi mandate={mandate} type={'assainissement'} title={false} />;
        case MandateType.TERRITOIRE:
        case MandateType.BASSIN:
            return (
                <>
                    <TechnicalIndicatorsDataUi mandate={mandate} type={'eau'} title={true} />
                    <TechnicalIndicatorsDataUi mandate={mandate} type={'assainissement'} title={true} />
                </>
            );
        default:
            return (
                <Box className={'technical-indicators__emptyScope'}>
                    <Typography>
                        Aucune configuration d&apos;indicateurs n&apos;est disponible pour ce mandat.
                    </Typography>
                </Box>
            );
    }
}
